// extracted by mini-css-extract-plugin
export default {"container":"About_container__WAkph","introBox":"About_introBox__A9cFN","introText":"About_introText__GB5Ie"};